"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JobDetailClickBookMarkSuccessEvent = exports.FavoriteClickBookMarkSuccessEvent = exports.JobClickFavoriteSuccessEvent = exports.JobClickShareSuccessEvent = void 0;
const base_event_1 = require("./base.event");
class JobClickShareSuccessEvent extends base_event_1.BaseEvent {
    constructor() {
        super(...arguments);
        this.type = 'JOB_CLICK_SHARE_SUCCESS';
    }
}
exports.JobClickShareSuccessEvent = JobClickShareSuccessEvent;
class JobClickFavoriteSuccessEvent extends base_event_1.BaseEvent {
    constructor() {
        super(...arguments);
        this.type = 'JOB_CLICK_FAVORITE_SUCCESS';
    }
}
exports.JobClickFavoriteSuccessEvent = JobClickFavoriteSuccessEvent;
class FavoriteClickBookMarkSuccessEvent extends base_event_1.BaseEvent {
    constructor() {
        super(...arguments);
        this.type = 'FAVOURITE_TAB_CLICK_BOOKMARK_SUCCESS';
    }
}
exports.FavoriteClickBookMarkSuccessEvent = FavoriteClickBookMarkSuccessEvent;
class JobDetailClickBookMarkSuccessEvent extends base_event_1.BaseEvent {
    constructor() {
        super(...arguments);
        this.type = 'JOB_DETAIL_CLICK_BOOKMARK_SUCCESS';
    }
}
exports.JobDetailClickBookMarkSuccessEvent = JobDetailClickBookMarkSuccessEvent;
//# sourceMappingURL=job.events.js.map